import { API_ROOT } from '../../config/config'
import { doGet } from './utils'

export const getProjectIndicators = () => {
  const url = `${API_ROOT}/subproject/project-indicators/page`
  return doGet(url)
}
export const getSearchProjectIndicators = (request) => {
  const url = `${API_ROOT}/subproject/project-indicators/page?year=${
    request.year || ''
  }&startDate=${request.startDate || ''}&endDate=${request.endDate || ''}&supTeamLeader=${
    request.supTeamLeader || ''
  }&supported=${request.supported || ''}&sector=${request.sector || ''}`
  return doGet(url)
}
